/** English is the typed source catalog. World content never belongs here. */
export const en = {
  "meta.description":
    "Seven CODEX nations wage war and revise their doctrines. You are the broker who buys weapons and resources cheaply and sells them at a profit.",
  "meta.title": "CODEX WAR BROKER",
  "WealthChart.increase": "up",
  "WealthChart.decrease": "down",
  "WealthChart.defaults_count":
    "{p0} defaults — marks where receivables disappeared",
  "Tutorial.briefing_step": "Briefing {p0} / {p1}",
  "NationTooltip.turn_count": "Turn {p0}",
  "events.buy": "buy",
  "events.sell": "sell",
  "App.front_unavailable": "Front unavailable",
  "App.try_again": "Try again",
  "App.connecting_to_the_front": "Connecting to the front",
  "App.opening_a_session_and_connecting_to_the":
    "Opening a session and connecting to the live channel",
  "App.the_map_engine_could_not_be_loaded":
    "The map engine could not be loaded",
  "brokerFleet.broker_hideout": "Broker hideout",
  "WorldScene.waiting_for_the_feed": "Waiting for the feed",
  "WorldScene.broker_hideout": "Broker hideout",
  "errors.order_not_found": "Order not found",
  "errors.this_is_not_a_sell_order": "This is not a sell order",
  "errors.this_is_not_a_buy_order": "This is not a buy order",
  "errors.not_enough_cash": "Not enough cash",
  "errors.nothing_remains_on_this_order": "Nothing remains on this order",
  "errors.quantity_must_be_at_least": "Quantity must be at least 1",
  "errors.unknown_nation": "Unknown nation",
  "errors.unknown_province": "Unknown province",
  "errors.that_nation_no_longer_exists": "That nation no longer exists",
  "errors.the_session_has_ended": "The session has ended",
  "errors.the_war_has_not_started_yet": "The war has not started yet",
  "errors.this_session_cannot_use_paid_agents_credentials":
    "This session cannot use paid agents — credentials or eligible nations are missing",
  "errors.this_session_is_no_longer_available":
    "This session is no longer available",
  "errors.session_not_found": "Session not found",
  "errors.not_found": "Not found",
  "errors.too_many_requests_please_try_again_shortly":
    "Too many requests. Please try again shortly",
  "errors.a_server_error_occurred": "A server error occurred",
  "errors.the_server_is_at_session_capacity_please":
    "The server is at session capacity. Please try again shortly",
  "errors.all_game_slots_are_full_right_now":
    "All game slots are full right now. Please try again shortly.",
  "errors.running_session_limit_for_this_connection":
    "This connection already has the maximum number of games running. Finish one before trying again.",
  "errors.pending_session_limit_for_this_connection":
    "This connection has too many game pages open. Close another tab and reload.",
  "errors.invalid_request": "Invalid request",
  "errors.invalid_request_25": "Invalid request",
  "errors.invalid_request_26": "Invalid request",
  "errors.invalid_request_27": "Invalid request",
  "errors.invalid_request_28": "Invalid request",
  "errors.the_front_is_unreachable_is_the_server":
    "The front is unreachable — is the server offline?",
  "errors.no_longer_holds_that_stock": "{p0} no longer holds that stock",
  "errors.cannot_pay_and_has_no_credit_remaining":
    "{p0} cannot pay, and has no credit remaining",
  "errors.cannot_pay_for_that": "{p0} cannot pay for that",
  "errors.is_already_at_war_with": "{p0} is already at war with {p1}",
  "errors.does_not_border": "{p0} does not border {p1}",
  "errors.is_not_at_war_with_that_nation":
    "{p0} is not at war with that nation",
  "errors.does_not_hold_that_province": "{p0} does not hold that province",
  "errors.no_longer_exists": "{p0} no longer exists",
  "errors.no_held_in_the_warehouse_or_in":
    "No {p0} held in the warehouse or in transit",
  "errors.no_in_the_warehouse": "No {p0} in the warehouse",
  "errors.no_in_the_warehouse_40": "No {p0} in the warehouse",
  "errors.request_failed": "Request failed ({p0})",
  "errors.unexpected_response_format": "Unexpected response format",
  "errors.the_war_could_not_be_started_check":
    "The war could not be started. Check the server connection and try again.",
  "events.session_started": "Session started",
  "events.session_ended": "Session ended — {p0}",
  "events.betrayed_its_alliance_and_declared_war_on":
    "{p0} betrayed its alliance and declared war on {p1}",
  "events.declared_war_on": "{p0} declared war on {p1}",
  "events.and_agreed_to_a_ceasefire": "{p0} and {p1} agreed to a ceasefire",
  "events.offered_an_alliance_to": "{p0} offered an alliance to {p1}",
  "events.and_formed_an_alliance": "{p0} and {p1} formed an alliance",
  "events.broke_its_alliance_with_lost_standing":
    "{p0} broke its alliance with {p1} — lost {p2} standing",
  "events.was_eliminated": "{p0} was eliminated",
  "events.captured_from": "{p0} captured {p2} from {p1}",
  "events.began_attacking_positions": "{p0} began attacking {p1} positions",
  "events.attackers_destroyed_can_counterattack":
    "{p0} attackers destroyed — {p1} can counterattack",
  "events.battle_subsided": "Battle subsided",
  "events.convoy_departed": "Convoy departed — {p0} {p1} → {p2}",
  "events.pickup_convoy": "Pickup convoy — {p0} {p1} ← {p2}",
  "events.convoy_lost_no_depot_for_delivery":
    "{p0} convoy lost — no depot for delivery",
  "events.arrived_at": "{p0} {p1} arrived at {p2}",
  "events.entered_the_broker_warehouse":
    "{p0} {p1} entered the broker warehouse",
  "events.posted_a_new_order": "{p0} posted a new order",
  "events.withdrew_an_order": "{p0} withdrew an order",
  "events.bought_from": "Bought {p1} {p2} from {p0} — {p3}",
  "events.sold_to": "Sold {p1} {p2} to {p0} — {p3}",
  "events.arrived_at_24": "{p0}: {p1} {p2} arrived at {p3}",
  "events.built_in": "{p0} built {p2} in {p1}",
  "events.production_cycle_resources_weapons":
    "{p0} production cycle — resources +{p1} / weapons +{p2}",
  "events.bought_on_credit_for_debt_balance":
    "{p0} bought on credit for {p1} — debt balance {p2}",
  "events.repaid_all_debt": "{p0} repaid all debt",
  "events.eliminated_written_off": "{p0} eliminated — {p1} written off",
  "events.offered_a_ceasefire_to": "{p0} offered a ceasefire to {p1}",
  "events.order_rejected": "{p0} order rejected — {p1}",
  "events.withdrew_a_order_for": "{p0} withdrew a {p2} order for {p1} — {p3}",
  "events.allied_aid_weapons": "{p0} → {p1} allied aid: {p2} weapons",
  "events.policy": "{p0} policy — {p1} ({p2})",
  "events.policy_35": "{p0} policy — {p1}",
  "events.requested_support_from_against":
    "{p0} requested support from {p1} against {p2}",
  "events.requested_support_from": "{p0} requested support from {p1}",
  "events.refused_a_request_from": "{p0} refused a request from {p1}",
  "events.weapons": "{p0} → {p1} {p2}: {p3} weapons",
  "events.received_no_answer_from": "{p0} did not answer the request from {p1}",
  "events.tribute_resources": "{p0} → {p1} tribute: {p2} resources",
  "labels.alliance": "Alliance",
  "labels.alliance_offered": "Alliance offered",
  "labels.standing": "Standing",
  "labels.betrayal": "Betrayal",
  "labels.no_allies": "No allies",
  "labels.policy": "Policy",
  "labels.royal_assessment": "Royal assessment",
  "labels.no_policy_set_yet": "No policy set yet",
  "labels.proclamation": "Proclamation",
  "labels.seek_ceasefire": "Seek ceasefire",
  "labels.request_support": "Request support",
  "labels.seek_alliance": "Seek alliance",
  "labels.conquest": "Conquest",
  "labels.withdraw_assault": "Withdraw assault",
  "labels.break_pact": "Break pact",
  "labels.last_stand": "Last stand",
  "labels.troops": "Troops",
  "labels.materiel_aid": "Materiel aid",
  "labels.refused": "Refused",
  "labels.weapons": "Weapons",
  "labels.resources": "Resources",
  "labels.resource_facility": "Resource facility",
  "labels.weapons_factory": "Weapons factory",
  "labels.housing": "Housing",
  "labels.capital": "Capital",
  "labels.factory": "Factory",
  "labels.depot": "Depot",
  "labels.ordinary": "Ordinary",
  "labels.expand": "Expand",
  "labels.defend": "Defend",
  "labels.recover": "Recover",
  "labels.trade": "Trade",
  "labels.seek_peace": "Seek peace",
  "labels.idle": "Idle",
  "labels.queued": "Queued",
  "labels.reading_state": "Reading state",
  "labels.evaluating": "Evaluating",
  "labels.command_issued": "Command issued",
  "labels.doctrine_updated": "Doctrine updated",
  "labels.failed": "Failed",
  "labels.offline": "Offline",
  "labels.deploy_troops": "Deploy troops",
  "labels.attack": "Attack",
  "labels.withdraw_assault_44": "Withdraw assault",
  "labels.fortify": "Fortify",
  "labels.build_facility": "Build facility",
  "labels.build_priority": "Build priority",
  "labels.buy_order": "Buy order",
  "labels.sell_order": "Sell order",
  "labels.war_declared": "War declared",
  "labels.offer_ceasefire": "Offer ceasefire",
  "labels.offer_alliance": "Offer alliance",
  "labels.break_alliance": "Break alliance",
  "labels.request_support_54": "Request support",
  "labels.answer_support": "Answer support",
  "labels.send_tribute": "Send tribute",
  "labels.unknown_command": "Unknown command",
  "labels.initial_assessment": "Initial assessment",
  "labels.strategy_review": "Strategy review",
  "labels.diplomatic_message": "Diplomatic message",
  "labels.war_declared_61": "War declared",
  "labels.territory_lost": "Territory lost",
  "labels.major_delivery": "Major delivery",
  "labels.capital_threatened": "Capital threatened",
  "labels.counterattack_opportunity": "Counterattack opportunity",
  "labels.market_shock": "Market shock",
  "labels.war_declared_67": "War declared",
  "labels.betrayal_68": "Betrayal",
  "labels.alliance_formed": "Alliance formed",
  "labels.ceasefire_agreed": "Ceasefire agreed",
  "labels.nation_eliminated": "Nation eliminated",
  "labels.territory_captured": "Territory captured",
  "labels.session_ended": "Session ended",
  "labels.previous_doctrine_retained": "Previous doctrine retained",
  "labels.agent_assessment_failed": "Agent assessment failed",
  "labels.agent_unresponsive": "Agent unresponsive",
  "labels.agent_unresponsive_77": "Agent unresponsive",
  "labels.debt": "Debt",
  "labels.credit_limit": "Credit limit",
  "labels.credit_remaining": "Credit remaining",
  "labels.accrued_interest": "Accrued interest",
  "labels.receivables": "Receivables",
  "labels.bad_debt": "Bad debt",
  "labels.sell_on_credit": "Sell on credit",
  "labels.info": "Info",
  "labels.trade_86": "Trade",
  "labels.war": "War",
  "labels.agent": "Agent",
  "labels.alert": "Alert",
  "labels.nations_are_making_live_decisions":
    "Nations are making live decisions.",
  "labels.live_codex_hybrid": "LIVE CODEX (hybrid)",
  "labels.some_nations_make_live_decisions_the_rest":
    "Some nations make live decisions; the rest use deterministic local agents.",
  "labels.local_decisions_recording": "Local decisions (recording)",
  "labels.deterministic_local_decisions_recorded":
    "Deterministic local agent decisions are recorded to disk; no model is called.",
  "labels.recorded_replay": "Recorded replay",
  "labels.replaying_previously_recorded_decisions_these_are_not":
    "Replaying previously recorded decisions. These are not live decisions.",
  "labels.mock_agents": "Mock agents",
  "labels.deterministic_local_agents_no_model_is_called":
    "Deterministic local agents. No model is called.",
  "serverText.in_progress": "In progress",
  "serverText.seven_game_minutes_elapsed_score_finalized_using":
    "Seven game minutes elapsed — final score calculated using current assets",
  "serverText.unified_the_continent_game_over":
    "{p0} unified the continent — game over",
  "serverText.seven_minutes_elapsed_final_assets":
    "Seven minutes elapsed — final assets",
  "serverText.unification_game_over": "Unification — game over",
  "serverText.game_ended_final_assets": "Game ended — final assets",
  "serverText.all_paid_sessions_are_occupied_concurrent_this":
    "All paid sessions are occupied ({p0} concurrent); this round uses mock agents until a slot opens",
  "serverText.mode_needs_codex_api_key_using_mock":
    "{p0} mode needs CODEX_API_KEY — using mock agents because credentials are missing",
  "serverText.session_decision_budget_exhausted":
    "Session decision budget exhausted",
  "serverText.agent_error": "Agent error",
  "serverText.turn": "{p0} turn {p1} — {p2} → {p3}",
  "serverText.fortification_breakthrough": "Fortification breakthrough",
  "serverText.western_front_emergency": "Western front emergency",
  "serverText.strategic_surplus": "Strategic surplus",
  "serverText.trimming_idle_reserves": "Trimming idle reserves",
  "serverText.counterattack_reserve": "Counterattack reserve",
  "serverText.peacetime_reserve_reduction": "Peacetime reserve reduction",
  "serverText.factories_are_starved_of_ore": "Factories are starved of ore",
  "serverText.mine_stock_overflowing": "Mine stock overflowing",
  "serverText.keeping_the_lines_running": "Keeping the lines running",
  "socket.broke_its_alliance_and_attacked":
    "{p0} broke its alliance and attacked {p1}",
  "socket.attacked": "{p0} attacked {p1}",
  "socket.captured": "{p0} captured {p1}",
  "socket.could_not_connect_to_the_operations_server":
    "Could not connect to the operations server",
  "socket.doctrine_updated": "{p0} doctrine updated",
  "CompanyNameGate.storage_is_blocked_your_company_name_will":
    "Storage is blocked. Your company name will last only in this tab.",
  "CompanyNameGate.enter_a_company_name_of_characters_without":
    "Enter a company name of 1–20 characters, without control characters.",
  "CompanyNameGate.could_not_save_your_company_name_in":
    "Could not save your company name in this browser.",
  "CompanyNameGate.broker_registration": "Broker registration",
  "CompanyNameGate.is_preparing_to_sail": "{p0} is preparing to sail",
  "CompanyNameGate.choose_your_company_name": "Choose your company name",
  "CompanyNameGate.sailing_with_your_saved_company_name":
    "Sailing with your saved company name.",
  "CompanyNameGate.this_name_will_be_used_for_every":
    "This name will identify your fleet on the map in every round. Once set, it cannot be changed.",
  "CompanyNameGate.company_name": "Company name",
  "CompanyNameGate.example_blue_sea_trading": "Example: Blue Sea Trading",
  "CompanyNameGate.the_server_calculates_the_final_score_directly":
    "The server calculates the final score directly.",
  "CompanyNameGate.sailing": "Sailing",
  "CompanyNameGate.try_again": "Try again",
  "CompanyNameGate.start_with_this_name": "Start with this name",
  "HudCorner.disconnected": "Disconnected",
  "HudCorner.connection_to_the_server_was_lost":
    "Connection to the server was lost.",
  "HudCorner.game_time_remaining_until_the_round_ends":
    "Game time remaining until the round ends",
  "NationTooltip.waiting": "Waiting",
  "NationTooltip.weapons_factories_mines_housing":
    "Weapons factories {p0} · Mines {p1} · Housing {p2}",
  "NationTooltip.doctrine_updated": "Doctrine updated —",
  "NationTooltip.province": "Province",
  "NationTooltip.treasury": "Treasury",
  "NationTooltip.morale": "Morale",
  "NationTooltip.province_facilities": "Province facilities",
  "NationTooltip.production_per_cycle": "Production per cycle",
  "NationTooltip.weapons": "Weapons",
  "NationTooltip.resources": "· Resources",
  "NationTooltip.agent": "Agent",
  "NationTooltip.turn": "Turn",
  "NationTooltip.royal_decision": "Royal decision",
  "NationTooltip.latest_decision": "Latest decision",
  "NationTooltip.no_decision_yet": "No decision yet",
  "NationTooltip.statement": "Statement",
  "NationTooltip.no_statement_yet": "No statement yet",
  "RestartButton.press_again_to_discard_this_round_and":
    "Press again to discard this round and open a new one",
  "RestartButton.open_a_new_round_the_current_round":
    "Open a new round. The current round will be discarded",
  "RestartButton.press_again": "Press again",
  "RestartButton.restart": "Restart",
  "ResultScreen.portal_score_note":
    "If you are logged in to justaigame.com, this score is automatically submitted to the portal rankings.",
  "ResultScreen.game_result_summary": "Game result summary",
  "ResultScreen.result_summary": "Result summary",
  "ResultScreen.cash": "Cash",
  "ResultScreen.unsold_inventory_is_valued_at_its_purchase":
    "Unsold inventory is valued at its purchase cost. Trading gains are recorded on sale.",
  "ResultScreen.inventory_cost": "Inventory cost",
  "ResultScreen.face_value_of_debt_owed_by_surviving":
    "Face value of debt owed by surviving nations. Net worth uses the cost below.",
  "ResultScreen.face_value": "(face value)",
  "ResultScreen.purchase_cost_of_goods_delivered_on_credit":
    "Purchase cost of goods delivered on credit. This contributes to net worth; margin is realized on repayment.",
  "ResultScreen.cost": "(cost)",
  "ResultScreen.unpaid_debt_of_eliminated_nations":
    "Unpaid debt of eliminated nations.",
  "ResultScreen.trading_profit_loss": "Trading profit/loss",
  "ResultScreen.net_worth": "Net worth",
  "ResultScreen.final_score": "Final score",
  "ResultScreen.bad_debt_was_already_removed_from_receivables":
    "Bad debt was already removed from receivables when the nation was eliminated — it is not deducted again from net worth.",
  "ResultScreen.territory_share": "Territory share",
  "ResultScreen.largest_power": "Largest power: {p0}",
  "ResultScreen.new_session": "New session",
  "TimeControls.pause": "Pause",
  "TimeControls.pause_both_the_war_and_the_seven":
    "Pause both the war and the seven-minute countdown",
  "TimeControls.run_at_normal_speed": "Run at normal speed",
  "TimeControls.run_at_double_speed": "Run at double speed",
  "TimeControls.run_at_quadruple_speed": "Run at quadruple speed",
  "TimeControls.game_speed": "Game speed",
  "TradePanel.not_enough_cash": "Not enough cash",
  "TradePanel.needs": "{p0} — needs {p1}",
  "TradePanel.no_stock_no_in_the_warehouse":
    "No stock — no {p0} in the warehouse",
  "TradePanel.this_is_of_the_average_price_across":
    "This is {p0}% of the average price across all orders for this good. Color compares supply prices; lower is better when buying.",
  "TradePanel.this_is_of_the_average_price_across_5":
    "This is {p0}% of the average price across all orders for this good. Color compares demand prices; higher is better when selling.",
  "TradePanel.sell": "Sell",
  "TradePanel.sell_7": "Sell 1 — {p0}",
  "TradePanel.the_treasury_cannot_pay_for_one_unit":
    "The treasury cannot pay for one unit — {p0} will be recorded as debt",
  "TradePanel.the_treasury_is_empty_one_unit_will":
    "The treasury is empty; one unit will be recorded as debt",
  "TradePanel.gift": "Gift",
  "TradePanel.treasury_and_credit_are_exhausted_give_one":
    "Treasury and credit are exhausted — give one unit free, with no payment or debt",
  "TradePanel.buy": "Buy",
  "TradePanel.buy_13": "Buy 1 — {p0}",
  "TradePanel.the_order_has_units_but_the_selected":
    "The order has {p0} units, but the selected province has {p1} — available to buy",
  "TradePanel.selected_province_stock_and_your_cash_are":
    "Selected province stock and your cash are sufficient — available to buy",
  "TradePanel.the_nation_can_pay_cash_available_to":
    "The nation can pay cash — available to sell",
  "TradePanel.the_nation_lacks_cash_sell_on_credit":
    "The nation lacks cash — sell on credit",
  "TradePanel.the_nation_has_no_cash_or_credit":
    "The nation has no cash or credit — gifts only",
  "TradePanel.unit": "/ unit",
  "TradePanel.market": "Market",
  "TradePanel.units": "units",
  "TradePanel.my_assets": "My assets",
  "TradePanel.cash": "Cash",
  "TradePanel.no_cash_the_cheapest_offer_costs_but":
    "No cash — the cheapest offer costs {p0}, but you have only {p1}. Sell something to raise cash.",
  "TradePanel.weapons_held": "Weapons held",
  "TradePanel.resources_held": "Resources held",
  "TradePanel.trading_partner": "Trading partner",
  "TradePanel.treasury": "Treasury",
  "TradePanel.cannot_pay_cash_the_cheapest_order_costs":
    "{p0} cannot pay cash — the cheapest order costs {p1}, but the treasury has only {p2}. You can sell on credit or give a gift.",
  "TradePanel.used": "{p0} {p1}: {p2} used — {p3} {p4}",
  "TradePanel.weapons_held_31": "Weapons held",
  "TradePanel.weapons_stationed_in": "Weapons stationed in {p0}",
  "TradePanel.resources_held_33": "Resources held",
  "TradePanel.resources_stored_in": "Resources stored in {p0}",
  "TradePanel.gift_of_to_accepted": "Gift of {p1} to {p0} accepted",
  "TradePanel.gift_give_without_payment": "Gift — give without payment",
  "TradePanel.to_the_selected_province": "To the selected province",
  "TradePanel.no_recipient": "No recipient",
  "TradePanel.held": "Held",
  "TradePanel.unit_40": "/ unit",
  "TradePanel.no_held_in_the_warehouse_or_in":
    "No {p0} held in the warehouse or in transit",
  "TradePanel.give_one_unit_free_to_no_payment":
    "Give one unit free to {p0}, {p1}. No payment or debt",
  "TradePanel.no_receiving_province": "No receiving province",
  "TradePanel.gift_44": "Gift",
  "TradePanel.buy_45": "Buy",
  "TradePanel.gift_46": "Gift",
  "TradePanel.sell_47": "Sell",
  "TradePanel.accepted_of_from_requested_units":
    "{p2} accepted: {p1} out of {p0} requested units — {p3}",
  "TradePanel.accepted_of": "{p1} accepted: {p0} — {p2}",
  "TradePanel.waiting_for_a_session": "Waiting for a session",
  "TradePanel.no_province_available_to_trade": "No province available to trade",
  "TradePanel.no_stock_in": "No stock in {p0}",
  "TradePanel.select_a_nation_on_the_map_to":
    "Select a nation on the map to trade here",
  "TradePanel.what_this_nation_wants_to_buy_demand":
    "What this nation wants to buy (demand)",
  "TradePanel.deliver_to": "Deliver to {p0}",
  "TradePanel.sell_here": "Sell here",
  "TradePanel.no_current_buy_orders": "No current buy orders",
  "TradePanel.what_this_nation_wants_to_sell_supply":
    "What this nation wants to sell (supply)",
  "TradePanel.collect_from": "Collect from {p0}",
  "TradePanel.buy_here": "Buy here",
  "TradePanel.no_current_sell_orders": "No current sell orders",
  "Tutorial.the_arms_broker_behind_seven_warring_nations":
    "The arms broker behind seven warring nations",
  "Tutorial.each_of_the_seven_nations_uses_a":
    "Each of the seven nations uses a *CODEX agent* to read the war and make its own decisions. You are an *arms broker* with cash and a warehouse fleet sailing slowly off the coast. Hover over a nation on the map to see its current aims at the bottom of the screen.",
  "Tutorial.only_weapons_and_resources_are_traded":
    "Only weapons and resources are traded",
  "Tutorial.resource_facilities_mine_resources_and_weapons_factories":
    "*Resource facilities* mine resources, and *weapons factories* use them to build weapons. Weapons are both the local army and sellable stock. *Peaceful nations* sell their surplus cheaply; *warring nations* pay a premium. The difference is your profit.",
  "Tutorial.keep_the_balance_and_earn_as_much":
    "Keep the balance and earn as much as possible",
  "Tutorial.if_one_nation_takes_the_continent_no":
    "If one nation takes the continent, no buyers or sellers remain. *Supply weapons to the losing side* to keep the war going, and sell on *credit* when a treasury runs dry. Your remaining *net worth* at the end is your score.",
  "Tutorial.briefing": "Briefing",
  "Tutorial.skip": "Skip",
  "Tutorial.start": "Start",
  "Tutorial.next": "Next",
  "WealthChart.total_assets": "Total assets",
  "WealthChart.total_assets_since_opening":
    "Total assets {p0}, {p1} {p2} since opening",
  "WealthChart.defaults": "Defaults:",
  "WealthChart.marks_where_receivables_disappeared":
    "— marks where receivables disappeared",
} as const;
